'use client'

import React from 'react'
import Image from 'next/image'

interface ProjectSightLogoProps {
  width?: number
  height?: number
  className?: string
}

const ProjectSightLogo: React.FC<ProjectSightLogoProps> = ({
  width = 150,
  height = 32,
  className = '',
}) => {
  // ProjectSight logo URL (local file with only the logo, no text)
  const logoUrl = '/nextassets/images/projectsight-logo.svg'

  return (
    <Image
      src={logoUrl}
      alt='ProjectSight Logo'
      width={width}
      height={height}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  )
}

export default ProjectSightLogo
